import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchTrendingArtists } from "../../redux/slices/artistSlice";
import { ChevronLeft, ChevronRight } from "lucide-react";
import classes from "./trendingArtists.module.css";
import { ARTIST_1, ARTIST_2 } from "../../utils/images";
import { useNavigate } from "react-router-dom";

const TrendingArtists = () => {
  const dispatch = useDispatch();
  const { trendingArtists, trendingArtistsLoading } = useSelector(
    (state) => state.artists
  );

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAutoplay, setIsAutoplay] = useState(true);
  const router = useNavigate();

  useEffect(() => {
    dispatch(fetchTrendingArtists({}));
  }, [dispatch]);

  useEffect(() => {
    let interval;
    if (isAutoplay && trendingArtists.length > 0) {
      interval = setInterval(() => {
        setCurrentIndex(
          (prevIndex) => (prevIndex + 1) % trendingArtists.length
        );
      }, 5000);
    }
    return () => clearInterval(interval);
  }, [isAutoplay, trendingArtists.length]);

  const goToPrevious = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + trendingArtists.length) % trendingArtists.length
    );
    setIsAutoplay(false);
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % trendingArtists.length);
    setIsAutoplay(false);
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsAutoplay(false);
  };

  const onClickBookArtist = (username) => {
    router(`profile/${username}`);
  };

  const visibleArtists =
    trendingArtists.length > 0
      ? [
          trendingArtists[
            (currentIndex - 1 + trendingArtists.length) % trendingArtists.length
          ],
          trendingArtists[currentIndex],
          trendingArtists[(currentIndex + 1) % trendingArtists.length],
        ]
      : [];

  return (
    <section id="trending-artist-section" className={classes.trendingSection}>
      <div className={classes.headerContainer}>
        <h2 className={classes.sectionTitle}>Trending Artists</h2>
        <p className={classes.sectionSubtitle}>
          Discover the creators making waves in the industry
        </p>
      </div>

      {trendingArtistsLoading ? (
        <p>Loading trending artists...</p>
      ) : (
        <>
          <div className={classes.carouselContainer}>
            <button
              className={`${classes.navButton} ${classes.prevButton}`}
              onClick={goToPrevious}
              aria-label="Previous artist"
            >
              <ChevronLeft size={24} />
            </button>

            <div className={classes.carouselTrack}>
              {visibleArtists?.map((artist, index) => {
                const isActive = index === 1;
                return (
                  <div
                    key={artist.id}
                    className={`${classes.carouselCard} ${
                      isActive ? classes.activeCard : ""
                    }`}
                    onClick={() => onClickBookArtist(artist?.username)}
                  >
                    <div className={classes.artistImageContainer}>
                      <div
                        className={classes.artistImage}
                        // style={{
                        //   backgroundImage: `url(${
                        //     artist?.profile_picture || ARTIST_2
                        //   })`,
                        //   backgroundSize: "cover",
                        //   width: "100%",
                        //   height: "100%",
                        // }}
                      >
                        <img
                          src={artist?.profile_picture || ARTIST_2}
                          alt={`${artist?.first_name} ${artist?.last_name}`}
                          className={classes.backgroundImg}
                        />
                        <img
                          src={artist?.profile_picture || ARTIST_2}
                          alt={`${artist?.first_name} ${artist?.last_name}`}
                          className={classes.foregroundImg}
                        />

                        <div className={classes.artistBadge}>
                          <span>
                            Rating : ⭐ {artist.rating || "No ratings yet"}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className={classes.artistInfo}>
                      <h3
                        className={classes.artistName}
                      >{`${artist?.first_name} ${artist?.last_name}`}</h3>
                      <p className={classes.artistSpecialty}>
                        {artist.specialty}
                      </p>
                      <button
                        className={classes.followButton}
                        disabled={true}
                        onClick={() => onClickBookArtist(artist?.username)}
                      >
                        Book Artist Coming Soon
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>

            <button
              className={`${classes.navButton} ${classes.nextButton}`}
              onClick={goToNext}
              aria-label="Next artist"
            >
              <ChevronRight size={24} />
            </button>
          </div>

          <div className={classes.indicators}>
            {trendingArtists.map((_, index) => (
              <button
                key={index}
                className={`${classes.indicator} ${
                  currentIndex === index ? classes.activeIndicator : ""
                }`}
                onClick={() => goToSlide(index)}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default TrendingArtists;
